<template>
	<div v-if="isHyperlinkModal" class="hyperlink-modal">
		<div class="input-container"  @click.stop>
			<VeeForm @submit="onSubmit">
				<input
					class="hyperlink-modal-input"
					v-model="linkInput"
					type="text"
					placeholder="Indsæt link"
				/>
				<input
					class="hyperlink-modal-input"
					style="margin-top: 5px;"
					v-model="titleInput"
					type="text"
					placeholder="Indsæt titel for linket"
				/>
				<button type="submit" style="display: none;">ok</button>
			</VeeForm>
		</div>
	</div>
</template>

<script setup>
import { Form as VeeForm } from "vee-validate";
import { ref, watch } from "vue";

const props = defineProps({
	isHyperlinkModal: Boolean,
	selectedText: String,
	selectedUrl: String,
	onSubmitHyperlink: Function,
	onClose: Function,
});

let listenerActive = false
const linkInput = ref(props.selectedUrl || "");
const titleInput = ref(props.selectedText || "");

const handleClickOutside = () => {
  if (listenerActive) {
    props.onClose();
	listenerActive = false;
  }
};

if(props.isHyperlinkModal){
	listenerActive = false;
	setTimeout(() => {
        listenerActive = true;
        window.addEventListener("click", handleClickOutside);
      }, 200);
}

watch(() => props.selectedUrl, (newValue) => {
	if (!linkInput.value) linkInput.value = newValue || "";
});

watch(() => props.selectedText, (newValue) => {
	if (!titleInput.value) titleInput.value = newValue || "";
});

const onSubmit = () => {
	const finalLink = linkInput.value.trim() || props.selectedUrl;
	const finalTitle = titleInput.value.trim() || props.selectedText;

	if (!finalLink) {
		return;
	}

	props.onSubmitHyperlink(finalLink, finalTitle);
};
</script>